import Vue from "vue";
import Router from "vue-router";

const portalHome = () => import('./views/portal/Home');
const portalPainel = () => import("./views/portal/Painel");
const portalProdutosPrevisul = () => import("./views/portal/ProdutosPrevisul");
const portalAjuda = () => import("./views/portal/Ajuda");
const portalMovimentacaoDeVidas = () =>
  import("./views/portal/MovimentacaoDeVidas");
const portalEmissoes = () => import("./views/portal/Emissoes");
const portalRelatorioGeral = () => import("./views/portal/RelatorioGeral");
const portalSinistro = () => import("./views/portal/Sinistro");
const portalInformesFiscais = () => import("./views/portal/InformesFiscais");
const portalComissoes = () => import("./views/portal/Comissoes");
// const portalColaboradores = () => import('./views/portal/Colaboradores');
// const portalColaboradorDetalhes = () => import('./views/portal/ColaboradorDetalhes');

const portalColaboradoresCadastroUnico = () =>
  import("./views/portal/ColaboradoresCadastroUnico");
const portalColaboradorDetalhesCadastroUnico = () =>
  import("./views/portal/ColaboradorDetalhesCadastroUnico");

const portalProcessosJudiciais = () =>
  import("./views/portal/ProcessosJudiciais");
// TODO: reativar quando o processamento de arquivos for liberado em produção
// const portalProcessamentoArquivosDFI = () =>
//   import("./views/portal/ProcessamentoArquivosDFI");
// const portalProcessamentoArquivosPrestamista = () =>
//   import("./views/portal/ProcessamentoArquivosPrestamista");
// const portalProcessamentoArquivosSQG = () =>
//   import("./views/portal/ProcessamentoArquivosSQG");
const portalSouMaisPrevisul = () => import("./views/portal/SouMaisPrevisul");
const portalConfiguracoes = () => import("./views/portal/Configuracoes");
const avisoSinistro = () => import("./views/portal/AvisoSinistro");

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "*", redirect: { path: "/Home" } },
    // { path: '*', redirect: { path: '/404' } },
    {
      path: "/404",
      name: "NotFound",
      component: () => import("./views/NotFound.vue"),
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "logout" */ "./views/Logout.vue"),
    },
    {
      path: "/callback",
      name: "callback",
      component: () =>
        import(/*webpackChunkName: "Callback" */ "./views/Callback"),
    },
    {
      path: "/RequestToken/:userRoleId?",
      name: "RequestToken",
      component: () =>
        import(/*webpackChunkName: "RequestToken" */ "./views/RequestToken"),
      props: true,
    },
    {
      path: "/Validate",
      name: "Validate",
      component: () =>
        import(/*webpackChunkName: "Validate" */ "./views/Validate"),
    },
    {
      path: "/unauthorized",
      name: "Unauthorized",
      component: () =>
        import(/*webpackChunkName: "Unauthorized" */ "./views/Unauthorized"),
    },
    { path: '/', name: 'Raiz', meta: { requiresAuth: true }, component: portalHome },
    { path: '/Home', name: 'Home', meta: { requiresAuth: true }, component: portalHome },

    {
      path: "/painel",
      name: "Painel",
      meta: { requiresAuth: true },
      component: portalPainel,
    },
    {
      path: "/produtos-previsul",
      name: "Produtos Previsul",
      meta: { requiresAuth: true },
      component: portalProdutosPrevisul,
    },
    {
      path: "/movimentacao-de-vidas",
      name: "Movimentação de Vidas",
      meta: { requiresAuth: true },
      component: portalMovimentacaoDeVidas,
    },
    {
      path: "/ajuda",
      name: "Ajuda",
      meta: { requiresAuth: true },
      component: portalAjuda,
    },
    {
      path: "/emissoes",
      name: "2ª via Digital",
      meta: { requiresAuth: true },
      component: portalEmissoes,
    },
    {
      path: "/relatorio-geral",
      name: "Relatórios de Clientes",
      meta: { requiresAuth: true },
      component: portalRelatorioGeral,
    },
    {
      path: "/sinistro",
      name: "Sinistro",
      meta: { requiresAuth: true },
      component: portalSinistro,
    },
    {
      path: "/informes-fiscais",
      name: "Informes Fiscais",
      meta: { requiresAuth: true },
      component: portalInformesFiscais,
    },
    {
      path: "/comissoes",
      name: "Comissões",
      meta: { requiresAuth: true },
      component: portalComissoes,
    },
    {
      path: "/avisoSinistro",
      name: "AvisoSinistro",
      meta: { requiresAuth: true },
      component: avisoSinistro,
    },
    // { path: '/colaboradores', name: "Colaboradores Antigos", meta: { requiresAuth: true }, component: portalColaboradores },
    // { path: '/colaborador-detalhes/:id?', name: "Colaboradores Antigos Detalhes", meta: { requiresAuth: true }, component: portalColaboradorDetalhes, props: true },

    {
      path: "/colaboradores",
      name: "Colaboradores",
      meta: { requiresAuth: true },
      component: portalColaboradoresCadastroUnico,
    },
    {
      path: "/colaborador-detalhes/:id?",
      name: "Colaboradores Detalhes",
      meta: { requiresAuth: true },
      component: portalColaboradorDetalhesCadastroUnico,
      props: true,
    },

    {
      path: "/processos-judiciais",
      name: "Processos Judiciais",
      meta: { requiresAuth: true },
      component: portalProcessosJudiciais,
    },
    // TODO: reativar quando o processamento de arquivos for liberado em produção
    // {
    //   path: "/processamento-arquivos-dfi",
    //   name: "Processamento de Arquivos DFI",
    //   meta: { requiresAuth: true },
    //   component: portalProcessamentoArquivosDFI,
    // },
    // {
    //   path: "/processamento-arquivos-prestamista",
    //   name: "Processamento de Arquivos Prestamista",
    //   meta: { requiresAuth: true },
    //   component: portalProcessamentoArquivosPrestamista,
    // },
    // {
    //   path: "/processamento-arquivos-sqg",
    //   name: "Processamento de Arquivos SQG",
    //   meta: { requiresAuth: true },
    //   component: portalProcessamentoArquivosSQG,
    // },
    {
      path: "/sou-mais-previsul",
      name: "Sou Mais Previsul",
      meta: { requiresAuth: true },
      component: portalSouMaisPrevisul,
    },
    {
      path: "/configuracoes",
      name: "Configurações",
      meta: { requiresAuth: true },
      component: portalConfiguracoes,
    },
  ],
});

export default router;

router.beforeEach(async (to, from, next) => {
  let app = router.app.$data || { isAuthenticated: false };

  if (to.name != "Validate") {
    localStorage.setItem("retornoValidate", to.name);
  }

  if (app.isAuthenticated) {
    next();
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    next("/Validate");
  } else {
    next();
  }
});
